import PropTypes from 'prop-types';

export const OEObjectModelValueTypes = {
    string:                     'string',
    bool:                       'bool',
    integer:                    'integer',
    float:                      'float',
    vec2:                       'vec2',
    vec2i:                      'vec2i',
    vec3:                       'vec3',
    vec3i:                      'vec3i',
    stringArray:                'stringArray',
    group:                      'group'
};

OEObjectModelValueTypes.all = Object.values(OEObjectModelValueTypes);

//
export const OEObjectModelValueEditTypes = {
    std:                        'std',
    dropdown:                   'dropdown'
};

OEObjectModelValueEditTypes.all = Object.values(OEObjectModelValueEditTypes);

//
export const OEObjectModelValueCellStyleOptions = {
    singleColumn:               'single-column',
    inlineBar:                  'inline-bar',
    scrollable:                 'scrollable',
    collapsible:                'collapsible',
};

OEObjectModelValueCellStyleOptions.all = Object.values(OEObjectModelValueCellStyleOptions);

//
export const OEObjectModelValueCellBtnIds = {
    newArrayEntry:              'newArrayEntry',
};

export const OEObjectModelValueIcons = {
    newArrayEntry:              '\uF055',
    dumpArrayEntry:             '\uF014',
    collapsed:                  '\uF078',
    notCollapsed:               '\uF077',
};

//
export const OEObjectModelValueEditHelper = {

    cellStyleOptionsToClassName(options, className)    {
        let optionClasses = '';
        if(typeof(options) === 'string')    {
            optionClasses = options;
        } else if(Array.isArray(options))   {
            options.forEach(option => {
                if(!option) return;
                optionClasses = (optionClasses ? optionClasses + ' ' : '') + option;
            });
        }

        if(!optionClasses.length)   return className;

        return (className ? className + ' ' : '') + optionClasses;
    },

    includesCellStyleOption(options, option)    {
        if(typeof(options) === 'string')    {
            return this.includesCellStyleOption([options], option);
        }

        if(!Array.isArray(options)) return false;

        return options.includes(option);
    },

    modelToCoreDictModel(model) {
        if(typeof(model) !== 'object' || !model)    return;

        const keys = Object.keys(model);
        let ret = {};

        keys.forEach(key => {
            const entry = model[key];
            if(typeof(entry) !== 'object' || !entry || typeof(entry.type) !== 'string' || !entry.type)    return;

            if(entry.type === OEObjectModelValueTypes.group)    return;

            if(entry.type === OEObjectModelValueTypes.stringArray)  {
                ret[key] = {type: 'array', model: OEObjectModelValueTypes.string};
            } else {
                ret[key] = entry.type;
            }
        });

        keys.forEach(key => {
            const entry = model[key];
            if(typeof(entry) !== 'object' || !entry || typeof(entry.type) !== 'string' || !entry.type)    return;

            if(entry.type !== OEObjectModelValueTypes.group)    return;

            const subModel = this.modelToCoreDictModel(entry.subItems);
            if(!subModel)   return;

            Object.keys(subModel).forEach(subModelKey => {
                if(!(subModelKey in ret))   return;
                console.log(`Warning - while converting object model value edit model to core dict model - found dublicate key - ${subModelKey} - in group`);
            });

            if(subModel)    Object.assign(ret, subModel);
        });

        return ret;
    }
};

//
export const OEObjectModelValueEditDecls = {

    modelItemLabels: PropTypes.objectOf(PropTypes.string),

    styleOptions: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

    vecValueCellLabels: PropTypes.shape({
        x:                      PropTypes.string,
        y:                      PropTypes.string,
        z:                      PropTypes.string
    }),

    dropDownCellEntry: PropTypes.shape({
        value:                  PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        label:                  PropTypes.string
    })
};

OEObjectModelValueEditDecls.dropDownCellEntries = PropTypes.arrayOf(OEObjectModelValueEditDecls.dropDownCellEntry);

OEObjectModelValueEditDecls.modelItemTypes = {
    className:                  PropTypes.string,
    type:                       PropTypes.string,
    editType:                   PropTypes.string,
    label:                      PropTypes.string,
    labelId:                    PropTypes.string,
    labels:                     OEObjectModelValueEditDecls.modelItemLabels,
    showType:                   PropTypes.bool,
    disabled:                   PropTypes.bool,
    allowUndefined:             PropTypes.bool,
    deferMinMaxConstraint:      PropTypes.bool,
    allowPartialUndefined:      PropTypes.bool,
    undefinedEditable:          PropTypes.bool,
    min:                        PropTypes.number,
    max:                        PropTypes.number,
    step:                       PropTypes.number,
    entries:                    OEObjectModelValueEditDecls.dropDownCellEntries,
    defaultDropdownTitle:       PropTypes.string,
    styleOptions:               OEObjectModelValueEditDecls.styleOptions,
    collapsed:                  PropTypes.bool
};

OEObjectModelValueEditDecls.modelItemTypes.subItems = PropTypes.objectOf(PropTypes.shape(OEObjectModelValueEditDecls.modelItemTypes));

OEObjectModelValueEditDecls.modelItem = PropTypes.shape(OEObjectModelValueEditDecls.modelItemTypes);

OEObjectModelValueEditDecls.model = PropTypes.objectOf(OEObjectModelValueEditDecls.modelItem);